import { useEffect, useState } from "react";
import api from "@/lib/api";
import { withDefaults } from "@/lib/pageSchemas";

// Fetches saved content for a page path and merges over the schema defaults.
// Returns null until loaded so pages can show a spinner if desired.
export function usePageContent(path) {
  const [content, setContent] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/public/page-content", { params: { path } })
      .then((r) => { if (alive) setContent(withDefaults(path, r.data)); })
      .catch(() => { if (alive) setContent(withDefaults(path, {})); });
    return () => { alive = false; };
  }, [path]);
  return content;
}
